
export const P02_01 = {
    "selectedValueColumn": "ItemCode",
    "selectedTitle": "Customer",
    "visual": [
        {
            "columns": 12,
            "rows": 3,
            "visual": {
                "id": 13,
                "type": "advancedTable",
                "colorTheme": "colorTheme1",
                "title": "Customer Sales Summary",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Customer Code',
                                "columnName": 'CustomerCode',
                                "width": '160px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Customer Name',
                                "columnName": 'CustomerName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Quantity Sold',
                                "columnName": 'QuantitySold',
                                "width": '160px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'YTD Quantity Sold',
                                "columnName": 'YTDQuantitySold',
                                "width": '200px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY YTD Quantity Sold',
                                "columnName": 'YTDLYQuantitySold',
                                "width": '200px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'QuantitySoldGrowth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            },
                            {
                                "name": 'Net Sales',
                                "columnName": 'ActualSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'YTD Net Sales',
                                "columnName": 'YTDActualSales',
                                "width": '150px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY YTD Net Sales',
                                "columnName": 'YTDLYSales',
                                "width": '170px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'YTDGrowth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": "CustomerName",
                        "endpoint": "P02.1",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "ConfigTypeCode", "value": "" },
                            { "key": "DistributorCode", "value": "" },
                            { "key": "ItemCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        }
    ],
}